import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DynComponent extends Vue {

  @Prop({default: () => undefined}) readonly clazz!: Function;
  @Prop({type: Object, default: () => {}}) readonly propz!: any;

  async forward<T>(prop, args = []): Promise<T> {
    return this.$refs.comp 
      && this.$refs.comp[prop]
      && this.$refs.comp[prop].apply(this.$refs.comp, args); 
  }

  render() {
    if (this.clazz) {
      const Comp = this.clazz;
      const attributes = {on: this.$listeners, props: this.propz};
      return <Comp ref="comp" {...attributes}/>;
    } else {
      return null;
    }
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-870b6a8a/dyn-component.tsx" });